/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecurityExportControlType
 */
export interface SecurityExportControlType {
    /**
     * 
     * @type {number}
     * @memberof SecurityExportControlType
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SecurityExportControlType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityExportControlType
     */
    textJa: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityExportControlType
     */
    textEn: string;
}

export function SecurityExportControlTypeFromJSON(json: any): SecurityExportControlType {
    return SecurityExportControlTypeFromJSONTyped(json, false);
}

export function SecurityExportControlTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityExportControlType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'textJa': json['textJa'],
        'textEn': json['textEn'],
    };
}

export function SecurityExportControlTypeToJSON(value?: SecurityExportControlType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'textJa': value.textJa,
        'textEn': value.textEn,
    };
}


